import { createSelector } from '@reduxjs/toolkit';
import { RootState } from './store';

export const buildingSelector = createSelector(
  (state: RootState) => state.building.buildings,
  (_: RootState, buildingId: string) => buildingId,
  (buildings, buildingId) => buildings.find((b) => b.uuid === buildingId)
);
